import { toastInfo, toastSuccess, toastError } from './toasts';
import config from '../config/config';
import { SellerSummaryDTO } from '../models/order';
import EventDTO from '../models/event';
import copyLinkToClipboard from './copyLinkToClipboard';
import { useLazyGetSellerEventQrQuery } from '../store';
import { BusinessDTO } from '../models/business';

const copyReferralLink = (business: BusinessDTO, event: EventDTO, summary: SellerSummaryDTO) => {
  const domain = business?.nickname
    ? `${business.nickname}.${config.domain}`
    : config.baseDomain;
  const link = business.nickname
    ? `${domain}/events/${event?.slug}?ref=${summary.referral?.code}`
    : `${domain}/events/${event?.slug}?ref=${summary.referral?.code}`;
  copyLinkToClipboard(link);
};

export const useDownloadQR = () => {
  const [getSellerEventQr] = useLazyGetSellerEventQrQuery();

  const handleDownloadQR = async (
    sellerSummary: SellerSummaryDTO,
    businessId: string,
    eventId: string,
  ) => {
    toastInfo('Descargando QR...');
    try {
      const res = await getSellerEventQr({
        businessId,
        eventId,
        userEventId: sellerSummary.user.current_event.id,
      }).unwrap();
      toastSuccess('QR descargado con éxito');
      const a = document.createElement('a');
      a.href = `data:image/png;base64,${res?.qr_image_b64}`;
      a.download = `qr_rrpp_${sellerSummary.seller_name}.png`;
      a.click();
    } catch {
      toastError('Error al descargar QR.');
    }
  };

  return handleDownloadQR;
};

export { copyReferralLink };
